module.exports = __webpack_public_path__ + "img/chess-queen.9f47cb27.svg";